import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import type { ComponentProps, ReactNode } from 'react';

type Props = {
  id: string;
  summary: ReactNode;
  children: ReactNode;
} & Omit<ComponentProps<typeof MuiAccordion>, 'children'>;

export const MobileAccordion = ({ id, summary, children, ...props }: Props) => {
  return (
    <MuiAccordion {...props}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
};
